import { render, staticRenderFns } from "./main-pileTab.vue?vue&type=template&id=3fec1114&scoped=true"
import script from "./main-pileTab.vue?vue&type=script&lang=js"
export * from "./main-pileTab.vue?vue&type=script&lang=js"
import style0 from "./main-pileTab.vue?vue&type=style&index=0&id=3fec1114&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fec1114",
  null
  
)

export default component.exports